export default __webpack_public_path__ + "static/media/11AW5NOV65.09a83c77.jpg";